import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = ({ isLoggedIn, isAdmin, onLogout, user }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const handleLogout = () => {
    onLogout();
    navigate('/');
    setMobileMenuOpen(false);
  };
  
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  
  return (
    <nav className="border-b bg-white sticky top-0 z-50 shadow-sm" data-testid="navbar">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3" data-testid="logo-link" onClick={closeMobileMenu}>
          <img src="/logo.png" alt="Cangkir Wanesia" className="h-10 w-10 object-contain" />
          <span className="text-xl font-semibold text-gray-900">Cangkir Wanesia</span>
        </Link>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-4">
          {isAdmin ? (
            <>
              <Link to="/admin/dashboard" data-testid="dashboard-link">
                <Button variant="ghost" size="sm">Dashboard</Button>
              </Link>
              <Link to="/analytics" data-testid="analytics-link">
                <Button variant="ghost" size="sm">Analytics</Button>
              </Link>
              <Link to="/users" data-testid="users-link">
                <Button variant="ghost" size="sm">Users</Button>
              </Link>
              <Link to="/logs" data-testid="logs-link">
                <Button variant="ghost" size="sm">Logs</Button>
              </Link>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={handleLogout}
                data-testid="logout-button"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </>
          ) : isLoggedIn ? (
            <>
              <Link to="/dashboard" data-testid="dashboard-link">
                <Button variant="ghost" size="sm">Dashboard</Button>
              </Link>
              <Link to="/api-tester" data-testid="api-tester-link">
                <Button variant="ghost" size="sm">API Tester</Button>
              </Link>
              <span className="text-sm text-gray-600">{user?.email}</span>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={handleLogout}
                data-testid="logout-button"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </>
          ) : (
            <Link to="/login">
              <Button size="sm" data-testid="login-nav-button">Login</Button>
            </Link>
          )}
        </div>
        
        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </Button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          className="md:hidden border-t bg-white"
          data-testid="mobile-menu"
        >
          <div className="container mx-auto px-4 py-4 space-y-2">
            {isAdmin ? (
              <>
                <Link 
                  to="/admin/dashboard" 
                  onClick={closeMobileMenu}
                  className="block"
                  data-testid="mobile-dashboard-link"
                >
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    Dashboard
                  </Button>
                </Link>
                <Link 
                  to="/analytics" 
                  onClick={closeMobileMenu}
                  className="block"
                  data-testid="mobile-analytics-link"
                >
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    Analytics
                  </Button>
                </Link>
                <Link 
                  to="/users" 
                  onClick={closeMobileMenu}
                  className="block"
                  data-testid="mobile-users-link"
                >
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    Users
                  </Button>
                </Link>
                <Link 
                  to="/logs" 
                  onClick={closeMobileMenu}
                  className="block"
                  data-testid="mobile-logs-link"
                >
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    Logs
                  </Button>
                </Link>
                <Button 
                  variant="outline" 
                  size="sm" 
                  onClick={handleLogout}
                  className="w-full justify-start"
                  data-testid="mobile-logout-button"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Logout
                </Button>
              </>
            ) : isLoggedIn ? (
              <>
                <Link 
                  to="/dashboard" 
                  onClick={closeMobileMenu}
                  className="block"
                  data-testid="mobile-dashboard-link"
                >
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    Dashboard
                  </Button>
                </Link>
                <Link 
                  to="/api-tester" 
                  onClick={closeMobileMenu}
                  className="block"
                  data-testid="mobile-api-tester-link"
                >
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    API Tester
                  </Button>
                </Link>
                <div className="px-3 py-2 text-sm text-gray-600">
                  {user?.email}
                </div>
                <Button 
                  variant="outline" 
                  size="sm" 
                  onClick={handleLogout}
                  className="w-full justify-start"
                  data-testid="mobile-logout-button"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Logout
                </Button>
              </>
            ) : (
              <Link to="/login" onClick={closeMobileMenu} className="block">
                <Button size="sm" className="w-full" data-testid="mobile-login-button">
                  Login
                </Button>
              </Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};